module.exports = __webpack_public_path__ + "media/all_conquering_tide.b44f4dda.mp3";